module.exports = __webpack_public_path__ + "img/instalacion-tuberias (3).d9a2f31e.jpg";